/**
 * @link https://mui.com/material-ui/react-toggle-button/
 */

import * as React from 'react';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/Check';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {Divider, Typography} from "@mui/material";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeToggleButtons() {
  const [formats, setFormats] = React.useState(() => ['bold', 'italic']);

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
  };

  const [selected, setSelected] = React.useState(false);

  return (
    <>
    <ToggleButtonGroup
      value={formats}
      onChange={handleFormat}
      aria-label="text formatting"
    >
      <ToggleButton value="bold" aria-label="bold">
        <FormatBoldIcon />
      </ToggleButton>
      <ToggleButton value="italic" aria-label="italic">
        <FormatItalicIcon />
      </ToggleButton>
      <ToggleButton value="underlined" aria-label="underlined">
        <FormatUnderlinedIcon />
      </ToggleButton>
      <ToggleButton value="color" aria-label="color" disabled>
        <FormatColorFillIcon />
        <ArrowDropDownIcon />
      </ToggleButton>
    </ToggleButtonGroup>
    <br/>
    <br/>

    <Divider textAlign={"left"}><Typography variant={"h6"}>Standalone toggle button</Typography></Divider>
      <ToggleButton
        value="check"
        selected={selected}
        onChange={() => {
          setSelected(!selected);
        }}
      >
        <CheckIcon />
      </ToggleButton>
    
      <ShowCode 
        codeString={`function ToggleButtonsExample() {
  const [formats, setFormats] = React.useState(['bold', 'italic']);

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
  };

  const [selected, setSelected] = React.useState(false);

  return (
    <>
      {/* Toggle Button Group */}
      <ToggleButtonGroup
        value={formats}
        onChange={handleFormat}
        aria-label="text formatting"
      >
        <ToggleButton value="bold" aria-label="bold">
          <FormatBoldIcon />
        </ToggleButton>
        <ToggleButton value="italic" aria-label="italic">
          <FormatItalicIcon />
        </ToggleButton>
        <ToggleButton value="underlined" aria-label="underlined">
          <FormatUnderlinedIcon />
        </ToggleButton>
        <ToggleButton value="color" aria-label="color" disabled>
          <FormatColorFillIcon />
          <ArrowDropDownIcon />
        </ToggleButton>
      </ToggleButtonGroup>

      <Divider textAlign="left" sx={{ my: 2 }}>
        <Typography variant="h6">Standalone toggle button</Typography>
      </Divider>
      
      {/* Standalone Toggle Button */}
      <ToggleButton
        value="check"
        selected={selected}
        onChange={() => {
          setSelected(!selected);
        }}
      >
        <CheckIcon />
      </ToggleButton>
    </>
  );
}`} 
        scope={{ 
          React, 
          FormatBoldIcon, 
          FormatItalicIcon, 
          FormatUnderlinedIcon, 
          FormatColorFillIcon, 
          ArrowDropDownIcon, 
          CheckIcon, 
          ToggleButton, 
          ToggleButtonGroup, 
          Divider, 
          Typography 
        }} 
      />
    </>
  );
}